import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuesax from 'vuesax'
import 'boxicons';
import 'vuesax/dist/vuesax.css'
import i18n from './language' // internationalization
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);



Vue.config.productionTip = false
Vue.use(Vuesax);


export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')